module.exports = __webpack_public_path__ + "img/sponsor-carousel-austal.d2b6974e.jpg";